import React, {useState} from "react";


const TextProp = ({propertyname, value, default_, onChange, width, array, arrayindex}) => {

    const [v, setv] = useState(value || default_);

    function handleChange(e) {
        let val = e
        setv(val)
        onChange(propertyname, val, array, arrayindex)
    }

    return (
         <input
                    style={{
                        width:  (width || 93) +'px',
                        border: '1px solid #222222',
                        marginLeft: '4px',
                        height: '15px',
                        color: '#C5B477',
                        background: '#777777',
                    }}
                    type="text" name={propertyname} value={v} onChange={(event) => handleChange(event.target.value)}/>
    )
}

export default TextProp